import React, { useEffect, useState } from 'react'
import CustomInput from '../CustomInput'
import CustomSelect from '../CustomSelect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { DriverInterface } from '../../types/driver-type';
import { providerPermissionFields } from '../providerComponents/providersData';
import { useDebounceCallback } from 'usehooks-ts';
import Chip from '../Chip';

interface ExtendedDriver extends DriverInterface {
    chaseItem?: Record<string, any>[],
    chaseType: string
}

interface TEditDriverForm {
    item: ExtendedDriver;
    RemoveDriver: (rId: string | number) => void;
    fetchDrivers: (driversData: {}) => void;
}

const EditDriverForm: React.FC<TEditDriverForm> = ({ item, RemoveDriver, fetchDrivers }) => {
    const { chaseItem, ...other } = item
    const [driver, setDriver] = useState<Record<string, any>>({ rId: item?.rId, chaseType: item?.chaseType, ...other })
    const [driverchaseItems, setDriverChaseItems] = useState<Record<string, any>[]>(chaseItem?.map((chaseItm: Record<string, any>) => ({ ...providerPermissionFields?.find((provData) => provData.id === chaseItm?.type), ...chaseItm })) || []);

    // ---------------------------------- [ UPDATE INPUT VALUES ] --------------------------------

    const HandleChangeDriverValues = useDebounceCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setDriver((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }, 200)


    const HandleAddChaseItem = (chaseItm: Record<string, any>) => {
        const isChase = driverchaseItems?.find((chase) => (chase?.type || chase?.id) === chaseItm?.id)

        if (isChase?.delete) {
            setDriverChaseItems((prev) => ([...prev.map((chaseItm) => chaseItm.id === isChase?.id ? { ...chaseItm, delete: false } : chaseItm)]))
        } else if (!isChase) {
            setDriverChaseItems((prev) => ([...prev, chaseItm]))
        }
    }

    const HandleDeleteChaseItem = (chaseItm: Record<string, any>) => {
        const isDefaultValue = chaseItem?.find((chase) => chaseItm?.type ? chase?.type === chaseItm?.type : chase?.type === chaseItm?.id)

        if (isDefaultValue) {
            setDriverChaseItems((prev) => ([...prev.map((item) => item?.id === chaseItm.id ? { ...item, delete: true } : item)]))
        } else {
            setDriverChaseItems((prev) => ([...prev.filter((item) => item?.id !== chaseItm.id)]))
        }
    }


    // ---------------------------------- [ SEND DATA TO PARENTER ] ---------------------------------
    useEffect(() => {
        if (driver?.name && driver?.chaseType) {
            const driverData = { ...driver, chaseItem: driverchaseItems, edit: !isNaN(item?.id) ? true : false }
            fetchDrivers(driverData)
        }
    }, [driver, driverchaseItems]) // eslint-disable-line




    return (
        <div className="bg-surface-muted border border-edge-faint rounded-xl p-5 smallTablet:p-4">
            <div className="flex items-center justify-between gap-4">
                <p className="text-[13px] font-semibold text-text-primary">Additional driver</p>
                <button
                    type="button"
                    title="Remove driver"
                    onClick={() => RemoveDriver(item?.id)}
                    className="h-8 w-8 rounded-lg flex items-center justify-center text-light-gray hover:text-rose-600 dark:hover:text-rose-300 hover:bg-rose-50 dark:hover:bg-rose-500/10 transition-colors duration-200"
                >
                    <FontAwesomeIcon icon={faTrash} className="text-[12px]" />
                </button>
            </div>

            <div className="mt-4 grid grid-cols-1 gap-5 smallTablet:gap-4">
                <CustomInput
                    autoComplete="none"
                    label="Full name"
                    defaultValue={driver?.name}
                    name='name'
                    onChange={HandleChangeDriverValues}
                />

                <div>
                    <CustomSelect
                        comboboxType="select"
                        options={providerPermissionFields}
                        labelProperty="label"
                        valueProperty="id"
                        label="Chase items"
                        placeholder="Select items"
                        onSingleSelectChange={(option: Record<string, any>) => HandleAddChaseItem(option)}
                    />

                    {driverchaseItems.filter((chaseItem) => !chaseItem?.delete)?.length ? (
                        <div className="pt-3 flex items-center justify-start flex-wrap gap-2">
                            {driverchaseItems.filter((chaseItem) => !chaseItem?.delete)?.map((chaseItem, index) => {
                                return <Chip result={chaseItem?.label} key={index + Math.floor(2)} className="cursor-pointer" onClick={() => HandleDeleteChaseItem(chaseItem)} />
                            })}
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    )
}

export default EditDriverForm
